import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { getTagStyles, getShapeStyles } from './styles.js';
import { Flex } from '../Flex/index.js';

/**
 * Tags are used for items that need to be labeled, categorized, or organized using keywords that describe them.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/tag#usage)
 * - [Props](https://blockparty.endpoint.com/components/tag#props)
 * <br />
 *
 */
const Tag = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    variantColor = 'open',
    variant = 'solid',
    shape = 'pill',
    ...rest
  } = _ref;
  const tagVariantStyles = getTagStyles({
    variant,
    variantColor
  });
  const tagShapeStyles = getShapeStyles({
    shape
  });
  return /*#__PURE__*/React__default.createElement(Flex, _extends({
    ref: forwardedRef,
    alignItems: "center",
    display: "inline-flex",
    fontSize: "fontSize10",
    height: "20px",
    justifyContent: "center",
    lineHeight: "lineHeight10",
    textAlign: "center"
  }, tagShapeStyles, tagVariantStyles, rest), children);
});

export { Tag };
